export default function (datasource, autoReconnect = false, userId = "") {
    const url = new URL(datasource)
    url.protocol = protocolSet(url.protocol);
    
    let onReconnect = null
    let onConnect = null
    let needReconnect = false
    let connecting = false
    let readyState = 0

    let environment = {}
    let ws

    let routes = {}

    const connect = async(reconnect = false) => {
        try {
            console.log("trying to connect...", url.toString())
            ws = new WebSocket(url.toString())

            ws.onopen = async () => { 
                console.log('Connection opened!'); 

                readyState = 1;

                if(onConnect) onConnect()

                console.log("sending user data");
                (await ws).send(JSON.stringify({
                    type: "user-info",
                    user: { id: userId },
                    message: {}
                }))

                if (reconnect && onReconnect) onReconnect(environment)
            }
        
            ws.onerror = () => {
                console.log("error")
                connecting = true
                setTimeout(connect, 3000)
            }

            ws.onclose = async() => { 
                console.log("Connection lost")
                readyState = 0
                if (autoReconnect && !connecting) connect(true)
            }
        
            ws.onmessage = function(e) {
                try {
                    const { type, message } = JSON.parse(e.data)
                    if (!routes[type]) throw "ERROR INVALID MESSAGE"

                    routes[type](message)
                } catch(e) {
                    console.log("UNACCEPTED MESSAGE")
                }
            };

        } catch(err) {
            console.log(err)
            setTimeout(connect, 3000)
        }
    }

    connect()

    window.addEventListener('online', () => {
        console.log("back online")
        connecting = true
        if (autoReconnect & needReconnect) connect(true)
        needReconnect = false
    });
    window.addEventListener('offline', () => {
        console.log("networking problem")
        needReconnect = true
    });

    return { 
        ws,
        setVar: (key, value) => { environment[key] = value },
        send: async(str) => { (await ws).send(str) },
        isActive: () => readyState == 1, 
        onReconnect: (action) => { onReconnect = action },
        onConnect: (action) => { onConnect = action },
        addEvent: (name, fnc) => { routes[name] = fnc }
    }
}

function protocolSet(actualProtocol = 'wss') {
    if (/wss?/.test(actualProtocol)) return actualProtocol

    if (/https/i.test(actualProtocol)) return 'wss'
    return 'ws'
}